import { rgba } from 'polished';

const CTA = '#E8308A';
const accent = '#E8308A';

export default {
  pink: {
    20: '#FFEFF1',
    50: '#FFF3F5',
    75: '#FFE1E5',
    100: '#F9D8DC',
    200: '#FFD7DC',
    300: '#FCEBED',
    400: '#EC5BA1',
    500: CTA,
    600: '#E83089',
    800: '#D64288',
    900: '#DB2A79',
  },
  gray: {
    50: '#F7F9F9',
    100: '#F1F3F8',
    200: '#E3E6E8',
    300: '#a0abb2',
    400: '#a1abb2',
    600: '#809999',
    500: '#7F9999',
    700: '#123233',
    900: '#003333',
  },
  green: {
    100: '#3E7F45',
    200: '#2D9A47',
    300: '#3FAE49',
    400: '#58F5CB',
    500: '#03D79E',
    600: '#C3E5C6',
    700: '#104040',
    800: '#CDE5D0',
    900: '#8CA3A3',
  },
  blue: {
    100: '#85DAFF',
    200: '#C8DCE8',
    300: '#4CABD5',
    400: '#E9F1F6',
    900: '#007DBB',
  },
  yellow: {
    200: '#F8E494',
    300: '#FAC43B',
    400: '#FDB714',
  },
  orange: {
    400: '#F36E24',
    900: '#CD8B2A',
  },
  red: {
    400: '#C92230',
    900: '#FF0000',
  },
  primary: {
    100: '#F9D8DC',
    200: '#FFD7DC',
    400: '#E8308A',
    500: '#E8308A',
  },
  secondary: {
    50: '#F7F9F9',
    100: '#F1F3F8',
    300: rgba('#003333', 0.1),
    400: '#A1ABB2',
    500: rgba('#003333', 0.5),
    700: rgba('#003333', 0.7),
    800: '#003333',
    900: '#003333',
  },
  other: {
    CTA,
    accent,
    counterBg: '#E8308A',
    sliderGray: '#B8C2C2',
    toastError: '#7F9999',
    toastSuccess: '#C3E5C6',
    settingsDivider: '#F1F2F3',
    tooltipBg: '#E8308A',
    orderCarbon: '#7F9999',
    orderFlight: '#85DAFF',
    orderEvent: '#FFB800',
    orderOther: '#FF4DA3',
    orderLifestyle: '#E8308A',
    orderPets: '#F8E494',
    orderCar: '#C3E5C6',
    successGreen: '#1ACB7F',
    statusPendingRetirement: '#94A4F8',
    statusReserved: '#56B7E9',
    statusPartiallyRetired: '#F1A12B',
  },
  charts: {
    flightsBar: '#85DAFF',
    employeesBar: '#E8308A',
    eventsBar: '#F8E494',
    carsBar: '#C3E5C6',
    carbonBar: '#7F9999',
    shippingBar: '#7F9999',
    otherBar: '#003333',
    emptyBar1: '#335C5C',
    emptyBar2: '#668585',
    emptyBar3: '#99ADAD',
    emptyBar4: '#CCD6D6',
  },
  impact: {
    weChoooseImpactSlide: '#C3E5C6',
  },
  pinkLink: '#DB2A79',
  greyLink: 'rgba(0, 51, 51, 0.5)',
  greyLinkActive: '#003333',
  menuButton: '#7F9999',
  blackLabel: '#1C1C1C',
  inputBorderColor: '#e2e8f0',
  pinkText: '#F497C5',
  facebookBlue: '#3578E5',
  googleBlue: '#4285F4',
  error: {
    primary: '#E53737',
    background: '#E5373708',
    overlay: rgba('#ff0000', 0.15),
  },
};
